// This file is AUTOGENERATED, do not edit it manually!!!

export const common = {
    activity: 'Aktivität',
    ai: 'AI',
    ai_analyzing: 'Muster werden analysiert',
    ai_building: 'Prognosenmodell wird erstellt',
    ai_description: 'Die {brandName} AI-Prognose verwendet Algorithmen des maschinellen Lernens, um anhand der historischen Daten Ihres Kontos Muster und Korrelationen zwischen Ereignissen und Aktionen zu finden. Als Ergebnis werden Ihnen das voraussichtliche Projektenddatum und die Konfidenz der Vorhersage angezeigt.',
    ai_forecast: 'AI-Prognose',
    ai_forecast_date: 'AI-Prognose für das Projektenddatum',
    ai_how_works: 'Erfahren Sie mehr über die Funktionsweise der AI',
    ai_not_enough_data: 'Nicht genügend historische Daten für eine zuverlässige Prognose. Eine aktive Nutzung des Systems ermöglicht präzisere Prognosen. <a href={0} target=\'_blank\' class={1}>Erfahren Sie mehr</a> über AI Forecast.',
    ai_planned_date: 'Geplantes Projektenddatum',
    ai_result: 'Ergebnisse der AI-Prognose',
    ai_reviewing: 'Überprüfung von historischen Daten',
    apply: 'Anwenden',
    available: 'Verfügbar',
    back: 'Zurück',
    CanDeleteCategoryHasTask: 'Es ist unmöglich, Kategorien zu löschen, die in Aktivitäten genutzt werden.',
    CanDeletePriorityHasProject: 'Es ist nicht möglich, Prioritäten zu löschen, die in Projekten verwendet werden.',
    CanDeletePriorityHasTask: 'Es ist nicht möglich, Prioritäten zu löschen, die in Aktivitäten verwendet werden.',
    CanDeletePriorityIsInternal: 'Es ist nicht möglich, interne Systemprioritäten zu löschen.',
    CanDeleteThresholdIsInternal: 'Es ist nicht möglich, den internen Systemschwellenwert zu löschen.',
    CanDeleteVacationTypeDefault: 'Es ist unmöglich, den Standardurlaubstyp zu löschen.',
    CanDeleteVacationTypeHasVacation: 'Es ist unmöglich, eine Urlaubstyp zu löschen, dem Urlaub zugewiesen ist.',
    CanDisableStatusIsUsed: 'Es ist nicht möglich, einen Status zu deaktivieren, der in einem Element verwendet wird',
    CanDisableStatusIsWorkflowTypeStatus: 'Es ist nicht möglich, den Standardstatus zu deaktivieren.',
    CanEditValueThresholdIsInternal: 'Die voreingestellten Schwellenwerte können nicht bearbeitet werden.',
    CanSetWorkflowTypeStatusIsWorkflowTypeStatus: 'Es ist nicht möglich, den Standardstatus erneut als Standardstatus zu markieren.',
    change: 'ändern',
    Completed_Projects: 'Abgeschlossene Projekte',
    Completed_Tasks: 'Abgeschlossene Aktivitäten',
    Copy_Text: 'Kopieren',
    copyPostfix: 'Kopieren',
    description_title: 'Beschreibung',
    Edit_Text: 'Bearbeiten',
    empty_list: 'Die Suche mit diesen Suchbegriffen bzw. mit dem aktiven Filter ergab keine Treffer',
    error_reload: 'Die Version von {brandName} wurde aktualisiert. Bitte laden Sie die Seite neu, damit die Anwendung korrekt ausgeführt wird.',
    export_csv: 'Als CSV exportieren',
    export_pdf: 'Als PDF-Datei exportieren',
    filters: 'Filter',
    from: 'Von',
    GotIt: 'OK!',
    here: 'hier',
    label_daily: 'Täglich',
    label_monthly: 'Monatlich',
    label_weekly: 'Wöchentlich',
    label_yearly: 'Jährlich',
    least_likely: 'Geringste Wahrscheinlichkeit',
    month: 'Monat',
    MoreActions: 'Weitere Aktionen',
    most_likely: 'Größte Wahrscheinlichkeit',
    name_title: 'Name',
    next_month: 'Nächster Monat',
    next_week: 'Nächste Woche',
    no: 'Nein',
    no_data_to_display: 'Keine Daten anzuzeigen',
    not_calculated: 'Nicht berechnet',
    PortfolioLimitError: 'Sie haben das Limit von 60 Portfolios in der Version Team Edition erreicht. Bitte führen Sie ein Upgrade auf die Version {brandName} Enterprise Edition durch.',
    previous_month: 'Vorheriger Monat',
    previous_week: 'Vorherige Woche',
    previous_year: 'Vorheriges Jahr',
    quarter: 'Quartal',
    read_more: 'Weitere Informationen',
    role: 'Rolle',
    select: 'Auswählen',
    share: 'Teilen',
    short_quarter0: 'Q1',
    short_quarter1: 'Q2',
    short_quarter2: 'Q3',
    short_quarter3: 'Q4',
    start_analyze: 'Analyse beginnen',
    sub_features_list_title: 'Diese Funktion beinhaltet:',
    this_month: 'Dieser Monat',
    this_week: 'Diese Woche',
    this_year: 'Dieses Jahr',
    ThresholdValueDuplicate: 'Dieser Schwellenwert wurde bereits hinzugefügt.',
    to: 'Bis',
    today: 'Heute',
    UnknownErrorMessage: 'Etwas ist schiefgegangen... Bitte laden Sie die Seite neu.',
    upgrade: 'Upgraden',
    week: 'Woche',
    WindowUnload_UnsavedChanges: 'Sie haben nicht gespeicherte Änderungen. Möchten Sie die Seite wirklich verlassen?',
    year: 'Jahr',
    yes: 'Ja',
    yesterday: 'Gestern',
};
